import React, { useState, useEffect, useReducer, useContext, useCallback } from "react";
import { makeStyles } from 'tss-react/mui';
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";
import Board from 'react-trello';
import { toast } from "../../services/toast";
import { i18n } from "../../translate/i18n";
import { useNavigate } from 'react-router-dom';
import { socketConnection } from "../../services/socket";
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { Tooltip } from "@mui/material";

const useStyles = makeStyles()(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  button: {
    background: "#10a110",
    border: "none",
    padding: "10px",
    color: "white",
    fontWeight: "bold",
    borderRadius: "5px",
  },

}));

const Kanban = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const [status, setStatus] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isInitialLoadComplete, setIsInitialLoadComplete] = useState(false);


  const fetchTags = async () => {
    try {
      const response = await api.post("/contact/status/list");
      const fetchedTags = response.data.data || [];
      setStatus(fetchedTags);
      await fetchTickets(jsonString);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  const [file, setFile] = useState({
    lanes: []
  });


  const [tickets, setTickets] = useState([]);
  const { user } = useContext(AuthContext);
  const { profile, queues } = user;
  const jsonString = user.queues.map(queue => queue.UserQueue.queueId);

  const fetchTickets = async (jsonString) => {
    try {
      const { data } = await api.get("/ticket/kanbanContact", {
        params: {
          queueIds: JSON.stringify(jsonString),
          teste: false
        }
      });
      setTickets(data.tickets);
    } catch (err) {
      console.log(err);
      setTickets([]);
    }
  };


  const ProfileContact = (type) => {
    switch (type) {
      case "PROSPECTO":
        return (
          <Tooltip title="Prospecto">
            <EmojiPeopleIcon
              height={17}
              style={{
                color: "#3b5998",
                position: "absolute",
                left: "210px",
                top: "40px",
                borderRadius: "10px",
                backgroundColor: "azure"
              }}
            />
          </Tooltip>
        );
      case "CLIENTE":
        return (
          <Tooltip title="Cliente">
            <HowToRegIcon
              height={17}
              style={{
                color: "#e1306c",
                position: "absolute",
                left: "210px",
                top: "40px",
                borderRadius: "10px",
                backgroundColor: "azure"
              }}
            />
          </Tooltip>
        );
      default:
        return null;
    }
  };

  const popularCards = (jsonString) => {
    const filteredTickets = tickets.filter(ticket => ticket.contact.statusId == null);

    const lanes = [
      {
        id: "lane0",
        title: i18n.t("Leads / Nuevos"),
        label: "0",
        cards: filteredTickets.map(ticket => ({
          id: ticket.id.toString(),
          label: "Ticket nº " + ticket.id.toString(),
          description: (
            <div>
              <p>
                {ticket.contact.number}
                <br />
                {ticket.lastMessage}
              </p>
              <button
                className={classes.button}
                onClick={() => {
                  handleCardClick(ticket.uuid)
                }}>
                Ver Ticket
              </button>
            </div>
          ),
          title: ticket.contact.name,
          draggable: true,
          href: "/tickets/" + ticket.uuid,
        })),
      },
      ...status.map(statu => {
        const filteredTickets = tickets.filter(ticket => {
          return ticket.contact.statusId === statu.id;
        });

        return {
          id: statu.id.toString(),
          title: statu.name,
          label: filteredTickets.length,
          cards: filteredTickets.map(ticket => ({
            id: ticket.id.toString(),
            label: "Ticket nº " + ticket.id.toString(),
            description: (
              <div>
                <p>
                  {ticket.contact.number}
                  <br />
                  {ticket.lastMessage}
                </p>
                {ProfileContact(ticket?.contact?.category?.name ?? '')}
                <button
                  className={classes.button}
                  onClick={() => {

                    handleCardClick(ticket.uuid)
                  }}>

                  Ver Ticket
                </button>
              </div>
            ),
            title: ticket.contact.name,
            draggable: true,
            href: "/tickets/" + ticket.uuid,
          })),
          style: { backgroundColor: "#5a5a5a", color: "white" }
        };
      }),
    ];

    setFile({ lanes });
  };

  const handleCardClick = (uuid) => {
    navigate('/tickets/' + uuid);
  };

  useEffect(() => {
    popularCards(jsonString);
  }, [status, tickets, reloadData]);

  const handleCardMove = async (cardId, sourceLaneId, targetLaneId) => {
    try {
      const ticket = tickets.find(t => t.id.toString() === targetLaneId);
      if (ticket?.contact?.id) {
        await api.post(`/contact/status/update`, {
          idStatus: sourceLaneId, 
          contactId: ticket.contact.id,
        });
        toast.success('¡Cambio de posición exitoso!');
      } else {
        toast.error('No se encontró el contacto asociado al ticket.');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error al cambiar la posición del ticket.');
    }
  };


  return (
    <div className={classes.root}>
      <Board
        data={file}
        onCardMoveAcrossLanes={handleCardMove}
        style={{ backgroundColor: 'rgba(252, 252, 252, 0.03)' }}
      />
    </div>
  );
};


export default Kanban;
